<spinner [center]="true" size="la-2x" color="grey" type="ball-triangle-path"></spinner>
<div class="row">
  <button *ngIf="clientPlatformService.clientType" mat-button fxLayoutAlign="start start" color="primary"
    (click)="connectionService.redirectToParent()">
    <mat-icon>arrow_back</mat-icon>
    <span style="margin-top: 10px; margin-left: 4px">Back</span>
  </button>
  <!--Connection Table-->
  <div class="column" style="margin: 10px">
    <mat-card appearance="outlined" fxLayout="column">
      <app-workspace *ngIf="uic.manageWorkspaceComponent('get') && authService.loggedIn" (dataRefresh)="initialize(true)" [parentPage]="'connection'"></app-workspace>

      <display-banner
      *ngIf="!clientPlatformService.clientType"
      [logo] = "'connection/appiworks-connection-logo.png'"
      [Title]="'Seamlessly connect and empower your solution'"
      [Tagline]="'Connect, manage, integrate and explore your applications'">
      </display-banner>
        <div *ngIf="!authService.loggedIn && !clientPlatformService.clientType" fxLayout="row" fxLayoutAlign="center center">
        <div  class="build_button_div" (click)="navigateToSignUp()">
          <div class="build_button" fxLayout="row">
            <div fxLayout="column" fxLayoutAlign="center start">
              <div style="font-size:  large;; font-weight: bold;" fxLayout="row"
              fxLayoutAlign="start center"> Build Now</div>
           </div>
          </div>
        </div>
      </div>

      <div style="height: .8rem"></div>

      <div style="margin: 0 0 5px 10px;">
        <button
            *ngIf="authService.loggedIn && !clientPlatformService.clientType"
            mat-button
            fxLayoutAlign="start center"
            routerLink="/home"
            color="primary"
          >
            <mat-icon color="primary">arrow_back</mat-icon>
            <span style="margin-top: 10px; margin-left: 4px">Back to Home</span>
          </button>
      </div>

      <header fxLayoutAlign="start center" fxLayout="row" fxLayout-xs="column" *ngIf="tableSourceData">
        <h2>Connections</h2>
        <!--Connection Search-->
        <mat-form-field appearance="outline" style="min-width: 20%;width: 100%;" [fxHide.xs]="!searchMobile">
          <mat-icon [ngClass.xs]="{'icon-button-small': true}" matPrefix >search
          </mat-icon>
          <mat-label [ngStyle.xs]="{'font-size':'x-small'}">
            <span>&nbsp;&nbsp;Search</span>
          </mat-label>
          <input matInput [(ngModel)]="connectionSearchField" fxFlexFill />
          <button class='icon-button-small' matSuffix mat-icon-button
            (click)="searchMobile=!searchMobile;connectionSearchField=''" style="margin-bottom: 14.25px" fxHide
            fxShow.xs>
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <button mat-button color="primary" [fxShow.xs]="!searchMobile" fxHide (click)="searchMobile=!searchMobile">
          <mat-icon>search</mat-icon>SEARCH
        </button>
      </header>
      <!-- <div fxLayout="column" fxLayoutAlign="center end" fxFlex="45">
        <button
          mat-flat-button
          color="primary"
          style="border-radius: 12px"
          (click)="createNewFlow()"
        >
          Create New Flow
        </button>
      </div> -->
      <!-- <div fxLayout fxLayoutAlign="center end" *ngIf="authService.loggedIn || clientPlatformService.clientType">
        <div fxFlex="80" fxLayoutAlign="space-between center">
        </div>
        <div>
          <button mat-flat-button color="primary" style="border-radius: 12px; margin-right: 5px;" (click)="createNewRecord()" matTooltip="Create new connection">
            Create new Connection
        </button>
        </div>
      </div> -->
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="authService.loggedIn || clientPlatformService.clientType">
        <div fxFlex="grow" fxLayoutAlign="end center">
          <button mat-flat-button color="primary" style="border-radius: 12px; margin-right: 5px;" (click)="createNewRecord()" matTooltip="Create new connection">
            Create new Connection
          </button>
        </div>
      </div>
      <!-- <div fxLayoutAlign="end center" [hidden]="!tableSourceData">
        <button mat-stroked-button color="primary" class="smallButton" (click)="refreshList()">
          <div fxLayout="row" fxLayoutAlign="center center">
            <span><mat-icon class="smallIcon" fxLayout="row" fxLayoutAlign="center center" style="margin-right: .3em;">refresh</mat-icon></span>
            <span>Refresh</span>
          </div>
        </button>
        <button mat-icon-button (click)="connectionListToggle()">
          <mat-icon color="primary" [matTooltip] = "selectedConnectionView === 'view_list' ? 'Show card view':'Show list view'">{{ selectedConnectionView }}</mat-icon>
        </button>
      </div> -->
      <div fxLayout fxLayoutAlign="center center" *ngIf="authService.loggedIn">
        <h1 class="heading" ><b>List of Connections</b></h1>
      </div>

      <app-list-panel *ngIf="connectionListMeta && authService.loggedIn"
        [panelMeta]="connectionListMeta"
        [builderMode]="false"
        (rowData)="rowClicked($event)"
      ></app-list-panel>
        <!-- [deleteLocalRow]="rowDeletionInChild" -->

      <span *ngIf="authService.loggedIn" [hidden]="tableSourceData" class="error" id="loading">
        <spinner></spinner>
      </span>
      <div fxLayout="end start" *ngIf="authService.loggedIn || clientPlatformService.clientType">
        <button mat-raised-button color="primary" style="margin-top: 10px; border-radius: 12px" (click)="createNewRecord()" matTooltip="Create new connection">
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" style="margin: 5px 0;">
            <div fxLayout="row" fxLayoutAlign="center center">
              <span style="margin-left: 3px;">Create new Connection</span>
            </div>
            <mat-spinner color="accent" *ngIf="spinner" diameter="20"></mat-spinner>
          </div>
        </button>
      </div>
    </mat-card>
  </div>
  <!-- Shared Connections -->
  <diV *ngIf="authService.loggedIn">
    <div fxLayout="row"   *ngIf="sharedConnections.length > 0" >
      <div fxLayout="column" fxFlex="2"></div>
      <div fxLayout="column" fxFlex="96">
        <h1 style="margin-bottom: 0px;"><b> Shared with me</b></h1>
      </div>
      <div fxLayout="column" fxFlex="2"></div>
    </div>

    <div fxLayout="row"   *ngIf="sharedConnections.length > 0" >
        <div fxLayout="column" fxFlex="2"></div>
        <div fxLayout="column" fxFlex="96">
            <mat-card   appearance="outlined"   class="list-card-head" fxLayout="row wrap"
                 layout-wrap fxLayoutAlign="start center"
                   style="word-break: break-all;width: 100%" >
                <div fxLayout="column wrap" style="text-align: center;word-break: break-word;" fxFlex="5">
                    #
                 </div>
                 <div fxFlex="5" fxLayout="column wrap" style="word-break: break-word;">

                    </div>
                <div fxFlex="20" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                    Name
                </div>
                <div fxFlex="25" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                </div>
                <div fxFlex="20" fxLayoutAlign="center start" fxLayout="column wrap" style="word-break: break-word;">
                </div>
                <div fxFlex="20" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                </div>
                <div fxFlex="5" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                Action
                </div>
              </mat-card>
        </div>
        <div fxLayout="column" fxFlex="2"></div>
      </div>

    <div fxLayout="row" *ngIf="sharedConnections.length > 0" >
        <div fxLayout="column" fxFlex="2"></div>
        <div fxLayout="column" fxFlex="96">
            <div   *ngFor="let connection of sharedConnections;let i = index; trackBy: trackByFn">
              <mat-card appearance="outlined" class="list-card" fxLayout="row wrap"
                 layout-wrap fxLayoutAlign="start center"
                   style="word-break: break-all;width: 100%" >
                <div fxLayout="column wrap" style="text-align: center;word-break: break-word;" fxFlex="5">
                    {{i + 1}}
                 </div>
                 <div fxFlex="5" fxLayout="column wrap" style="word-break: break-word;">
                    <img src="{{ connection.options['box_logo_url'] }}" [ngStyle]="{'height': '30px', 'width': '30px'}" [matTooltip]="connection.options.box_name || connection.box_id"
                    fxHide.lt-sm />
                 </div>
                <div fxFlex="20" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                  {{ connection.name}}
                </div>
                <div fxFlex="25" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                </div>
                <div  fxFlex="20" fxLayoutAlign="center start" fxLayout="column wrap" style="word-break: break-word;">
                </div>
                <div matTooltip="Status" fxFlex="20" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;">
                </div>
                <div fxFlex="5" fxLayout="column wrap" fxLayoutAlign="center start" style="word-break: break-word;" >
                  <mat-icon style="margin: 0px;cursor: pointer;" (click)="exploreConnection(connection)">visibility</mat-icon>
                </div>
              </mat-card>
            </div>
        </div>
        <div fxLayout="column" fxFlex="2"></div>
      </div>
  </diV>
  <div class="auth-error" *ngIf="authError">
    <mat-card appearance="outlined">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1rem" style="width: 100%;">
        <div style="text-align: center; width: 100%;">Workspace not loaded. Try signing in.</div>
        <button mat-raised-button class="signin-button" [routerLink]="['/']">
            Sign in
        </button>
      </div>
    </mat-card>
  </div>
</div>

<!-- <app-list-panel [panelMeta]="panelMeta" [builderMode]="builderMode">
</app-list-panel> -->



